import {useCallback} from 'react';
import {useGetStoreSettingsQuery} from '../api/storesApi';
import {useStoreSlug} from './useStoreSlug';

interface UseSettingIsAvailable {
  settingIsAvailable: (name: string) => boolean;
}

const settingReady = (name: string) => {
  const unreadySettings = ['autofulfill'];
  return !unreadySettings.includes(name);
};

export const useSettingIsAvailable = (): UseSettingIsAvailable => {
  const urlSlug = useStoreSlug();
  const {data: storeSettings} = useGetStoreSettingsQuery(urlSlug);
  const settingKeys = storeSettings ? Object.keys(storeSettings) : [];

  const settingIsAvailable = useCallback(
    (name: string) => {
      return settingKeys.includes(name) && settingReady(name);
    },
    [settingKeys]
  );

  return {settingIsAvailable};
};

export default useSettingIsAvailable;
